import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "block w-full text-xs",
    "data-accordion-toggle": ""
};
const _hoisted_2 = { class: "overflow-hidden" };
import SvgIcon from '@atoms/SvgIcon.vue';
import { reactive } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccordionToggle',
    props: {
        title: {},
        titleClasses: {}
    },
    setup(__props) {
        const state = reactive({
            isOpen: false,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    class: _normalizeClass(["flex w-full cursor-pointer items-center justify-between gap-4 font-bold", _ctx.titleClasses]),
                    onClick: _cache[0] || (_cache[0] = ($event) => (state.isOpen = !state.isOpen))
                }, [
                    _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                    _createElementVNode("span", {
                        class: _normalizeClass([{
                                'rotate-90': !state.isOpen,
                                '-rotate-90': state.isOpen,
                            }, "h-4 w-4 origin-center transform transition-transform lg:h-5 lg:w-5"])
                    }, [
                        _createVNode(SvgIcon, { name: "chevron" })
                    ], 2)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass([{
                            'grid-rows-0': !state.isOpen,
                            'grid-rows-1 pt-4': state.isOpen,
                        }, "grid grid-cols-1 transition-all"])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "default")
                    ])
                ], 2)
            ]));
        };
    }
});
